import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
// import { Helmet } from "react-helmet";
import Header from "../../components/header";

import Footer from "../../components/footer";
import CardLeftRight from "../../components/cardleftright";
import { dataListsType } from "../../shared/type";
import AdPage from "../../components/AdPage";
import { DataLists } from "../../dataLists/DataLists";

import { HelmetSeo } from "../../components/HelmetSeo";

interface FoodSectionProps {
  foodData: dataListsType[];
  nation: string;
}

const FoodSection = ({ nation, foodData }: FoodSectionProps) => (
  <div className="w-full mb-16 px-8">
    <div className="mb-8 border-b-[1px]">
      <h5 className="uppercase text-sm font-semibold pt-2 pb-2 tracking-wider flex justify-between">
        <span>
          <b className="text-[#181818]">{nation}</b> Food
        </span>
        <Link
          className="font-bold text-[#c9b077]"
          to={{
            pathname: "/morepage",
            search: `?category=Food&nation=${encodeURIComponent(
              nation,
            )}&label=${encodeURIComponent(`${nation} Food`)}`,
          }}
        >
          MORE{">>"}
        </Link>
      </h5>
      <span className="block w-16 h-[3px] bg-[#c9b077]"></span>
    </div>
    <div className="w-full flex flex-col gap-y-10">
      <CardLeftRight
        props={foodData.sort(() => Math.random() - 0.5).slice(0, 4)}
      />
    </div>
  </div>
);

export default function Food() {
  const [foodData, setFoodData] = useState<{
    China: dataListsType[];
    Japan: dataListsType[];
    Indonesia: dataListsType[];
    // Singapore: dataListsType[];
  }>({
    China: [],
    Japan: [],
    Indonesia: [],
    // Singapore: [],
  });

  useEffect(() => {
    const allData = DataLists.filter((item) => item.category === "Food");
    setFoodData({
      Indonesia: allData.filter((item) => item.nation === "Indonesia"),
      // Singapore: allData.filter((item) => item.nation === "Singapore"),
      China: allData.filter((item) => item.nation === "China"),
      Japan: allData.filter((item) => item.nation === "Japan"),
    });
  }, []);

  return (
    <>
      <HelmetSeo
        title="Asian Food Guide - Explore Traditional Cuisines & Restaurants"
        description="Explore the rich flavors of Asian cuisine, from authentic Chinese dishes to Japanese delicacies and Indonesian specialties. Discover local restaurants and food guides."
        ogType="website"
      />
      <Header />

      <AdPage />
      <div className="w-full h-full fixed top-0 left-0 -z-10 bg-white/60 bg-blend-overlay backdrop-blur-md"></div>
      {/* <Helmet>
        <title>
          Asian Food Guide - Explore Traditional Cuisines & Restaurants
        </title>
        <meta
          name="description"
          content="Explore the rich flavors of Asian cuisine, from authentic Chinese dishes to Japanese delicacies and Indonesian specialties. Discover local restaurants and food guides."
        />
      </Helmet> */}
      <div className="w-full flex justify-center">
        <div className="flex flex-col justify-center 2xl:max-w-[1500px] max-w-[1200px] my-8">
          <h1 className="text-3xl font-extrabold px-8 pb-3">Food</h1>
          {Object.entries(foodData).map(([nation, data]) => (
            <FoodSection key={nation} nation={nation} foodData={data} />
          ))}
        </div>
      </div>
      <Footer />
    </>
  );
}
